import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import { ReactNode } from 'react'
import { error, errorD1 } from 'shared/theme/colors'
import styled from 'styled-components'

import { MessageContainer, MessageIcon } from './styles'

interface ErrorMessageProps {
  children: ReactNode
  alignCenter?: boolean
  className?: string
  isSlim?: boolean
  mt?: number
}

export const ErrorMessageList = styled.ul`
  margin: 0;
  padding: 10px 0 0 18px;
`

export function ErrorMessage({ children, alignCenter, className, isSlim, mt }: ErrorMessageProps) {
  return (
    <MessageContainer
      $background={error}
      $alignCenter={alignCenter}
      className={className}
      $isSlim={isSlim}
      $mt={mt}
    >
      <MessageIcon $color={errorD1} Icon={ErrorOutlineIcon} />
      <div>{children}</div>
    </MessageContainer>
  )
}
